export enum ScheduleModeEnum {
  Immediate,
  DelaySend,
  Recurring,
}
